import pull from 'lodash/pull';
import find from 'lodash/find';
import range from 'lodash/range';
import { sumBy } from 'lodash';
import ParticipationSurveyCard from '../participationSurveyCard';
import ParticipationOfferCard from '../participationOfferCard';
import Icon from '../../components/icons';
import request from '../../request';
import {
  OFFERWALL_TABS,
  OFFERS_REWARDS_FILTERS,
  OFFERS_DYNAMIC_TYPE,
  OFFERS_HISTORY_STATUS,
} from '../../constants';
import { publicAssetsPrefix } from '../../../../../configuration';
import { getLocaleDate } from '../../utils';

const emptyState = (text, icon) => `
  <article class="flex-full-width card-v2 margin-sm-btm">
    <section class="card-v2-body text-align-center">
      <p class="margin-sm">${icon}</p>
    </section>
    <footer class="card-v2-footer">
      <div class="divider margin-md-btm"></div>
      <div class="text-align-center">
        <p class="text-grey margin-reset">${text}</p>
      </div>
    </footer>
  </article>
`;
class PointsPage {
  constructor() {
    this.getText = Pollfish.ui.getText;
    this.container = document.createElement('div');
    this.participations = [];
    this.dailyPoints = 0;
    this.pendingPoints = 0;
    this.pointsName = Pollfish.helper.json.reward_name || 'Points';
    this.pendingSurveyIds = [];
    this.offerParticipations = [];
    this.surveysEnabled = Pollfish.helper.getOfferwallSurveysEnabled();
    this.offersEnabled = Pollfish.helper.getOfferwallOffersEnabled();
    this.onlyOne =
      (this.surveysEnabled && !this.offersEnabled) ||
      (!this.surveysEnabled && this.offersEnabled);
    this.activeTab = OFFERWALL_TABS.SURVEYS;
    this.activeFilter = OFFERS_REWARDS_FILTERS.ALL;
    this.activeOffer = null;
    this.loadingOffer = false;
  }

  getPoints() {
    this.container.innerHTML = `<div class="container">${Pollfish.ui.getSpinner()}</div>`;
    request({ url: '/v2/device/offerwall/points' })
      .then((payload = {}) => {
        if (!payload.success) {
          this.container.innerHTML = `<div class="container"><div class="margin-md">${this.renderErrorState()}</div></div>`;
          return;
        }

        this.showNotification(payload.data.participations);
        this.dailyPoints = payload.data.dailyPoints;
        this.pendingPoints = payload.data.pendingPoints;
        this.pointsName = payload.data.pointsName;
        this.participations = payload.data.participations;
        this.offerParticipations = payload.data.offerParticipations;
        this.onChange();
        this.render();
      })
      .catch(() => {
        this.container.innerHTML = `<div class="container"><div class="margin-md">${this.renderErrorState()}</div></div>`;
      });
  }

  onChange() {
    this.onChangeCallback(
      this.dailyPoints,
      this.pendingPoints,
      this.pointsName,
    );
  }

  onPointsChange(callback) {
    this.onChangeCallback = callback;
  }

  showNotification(nextParticipations) {
    const { participations } = this;

    // concatenate all pending survey ids
    const pendingSurveyParticipations = participations.reduce(
      (accumulator, participation) => {
        if (participation.status === 'pending') {
          accumulator.push(participation.s_id);
        }

        return accumulator;
      },
      this.pendingSurveyIds,
    );

    const rewarded = find(nextParticipations, (participation) => {
      if (pendingSurveyParticipations.indexOf(participation.s_id) > -1) {
        return participation.status === 'success';
      }
      return false;
    });

    const screenOut = find(nextParticipations, (participation) => {
      if (pendingSurveyParticipations.indexOf(participation.s_id) > -1) {
        return participation.status === 'screened_out';
      }
      return false;
    });

    if (rewarded) {
      const successText = this.getText(
        'offerwall.notifications.congratulations',
      );
      const prompt = successText.replace(
        '...',
        `${rewarded.pointsValue} ${rewarded.pointsName}`,
      );
      Pollfish.ui.promptSuccess(prompt);
      pull(this.pendingSurveyIds, rewarded.s_id);
    }

    if (screenOut) {
      const promptText = this.getText('offerwall.notifications.disqualified');
      Pollfish.ui.promptError(promptText);
      pull(this.pendingSurveyIds, screenOut.s_id);
    }
  }

  renderEmptyState({ forOffers = false } = {}) {
    const { getText } = this;
    const emptyStateText = forOffers
      ? getText('offerwall.empty_history_offers')
      : getText('offerwall.empty_history');
    return emptyState(
      emptyStateText,
      Icon({ type: 'empty', color: '#848d9e', size: 56 }),
    );
  }

  renderErrorState() {
    const { getText } = this;
    const text = getText('offerwall.error');
    return emptyState(text, Icon({ type: 'error', size: 56 }));
  }

  renderHistoryTab() {
    const { activeTab, getText } = this;
    const surveysEnabled = Pollfish.helper.getOfferwallSurveysEnabled();
    const offersEnabled = Pollfish.helper.getOfferwallOffersEnabled();
    const onlyOne =
      (surveysEnabled && !offersEnabled) || (!surveysEnabled && offersEnabled);
    const classNames = `inline-block reset-button offerwall-filters-tab js-points-tabs ${
      onlyOne ? 'offerwall-filters-tab-only-one' : ''
    }`;
    const titleSurveys = `${getText(
      'offerwall.history.survey_history',
    )} (${getText('offerwall.history.24_hours')})`;
    const titleOffers = getText('offerwall.history.offer_history');
    return `
      <header
        class="flex offerwall-filters rewards"
        style="background-color: #fff;"
      >
        <section class="flex flex-1 container flex-align-items--center">
          <div class="flex-1">
            ${
              surveysEnabled
                ? `<button
                class="${
                  activeTab === OFFERWALL_TABS.SURVEYS
                    ? 'offerwall-filters-tab-selected'
                    : ''
                } ${classNames}"
                type="button"
                data-tab="${OFFERWALL_TABS.SURVEYS}"
              >
              ${titleSurveys}
              </button>`
                : ''
            }
            ${
              offersEnabled
                ? `<button
                class="${
                  activeTab === OFFERWALL_TABS.OFFERS
                    ? 'offerwall-filters-tab-selected'
                    : ''
                } ${classNames}"
                type="button"
                data-tab="${OFFERWALL_TABS.OFFERS}"
              >
              ${titleOffers}
              </button>`
                : ''
            }
          </div>
        </section>
      </header>
    `;
  }

  renderSurveysParticipation() {
    const { getText, participations } = this;
    return `
      <section class="flex flex-wrap">
        ${participations
          .map((participation) =>
            ParticipationSurveyCard(participation, getText),
          )
          .join('')}
        <p class="text-align-center">
          ${participations.length === 0 ? this.renderEmptyState() : ''}
        </p>
      </section>`;
  }

  activeParticipations(offerParticipations, activeFilter) {
    if (activeFilter === OFFERS_REWARDS_FILTERS.IN_PROGRESS) {
      return offerParticipations.filter((offer) => !offer.completed);
    }

    if (activeFilter === OFFERS_REWARDS_FILTERS.COMPLETED) {
      return offerParticipations.filter((offer) => offer.completed);
    }

    return offerParticipations;
  }

  renderOfferParticipations() {
    const { getText, offerParticipations, activeFilter } = this;

    if (offerParticipations.length === 0) {
      return `<section class="flex flex-column flex-align-items--center flex-justify--center" style="margin-top: 60px;">
      <img src="${publicAssetsPrefix}/img/no-offers.png" alt="No offers" />
      <p>${getText('offerwall.history.offersEmpty')}</p>
      </section>`;
    }

    const filteredOfferParticipations = this.activeParticipations(
      offerParticipations,
      activeFilter,
    );

    return `
    <section class="flex flex-wrap">
        ${filteredOfferParticipations
          .map((participation, index) =>
            ParticipationOfferCard(
              participation,
              getText,
              `participation-offer-card-${index}`,
            ),
          )
          .join('')}
        <p class="text-align-center">
          ${
            offerParticipations.length === 0
              ? this.renderEmptyState({ forOffers: true })
              : ''
          }
        </p>
      </section>`;
  }

  selectOffer(offer) {
    const offerId = offer && offer.offerId;
    this.activeOffer = offer;
    this.loadingOffer = true;
    this.render();

    request({ url: `/v2/device/offerwall/offers/${offerId}/history` })
      .then((payload = {}) => {
        this.activeOffer = payload;
        this.loadingOffer = false;
        this.render();
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        this.loadingOffer = false;
        this.render();
      });
  }

  selectFilter(filter) {
    this.activeFilter = filter;
  }

  getOngoingOffersCount(offerParticipations) {
    return offerParticipations.filter((offer) => !offer.completed).length;
  }

  getCompletedOffersCount(offerParticipations) {
    return offerParticipations.filter((offer) => offer.completed).length;
  }

  renderOffersRewardsFilters() {
    const {
      activeTab,
      activeFilter,
      getText,
      offerParticipations = [],
      getOngoingOffersCount,
      getCompletedOffersCount,
    } = this;

    if (offerParticipations.length === 0) {
      return '';
    }

    return `
      <section class="container offerwall-offer-categories" style="display: ${
        activeTab === OFFERWALL_TABS.OFFERS ? 'block' : 'none'
      }">
        <button
          type="button"
          class="reset-button offerwall-offer-categories-btn js-offer-rewards-filter-btn ${
            activeFilter === OFFERS_REWARDS_FILTERS.ALL
              ? 'offerwall-offer-categories-btn-selected'
              : ''
          }"
          data-value="${OFFERS_REWARDS_FILTERS.ALL}"
          data-testid="offer-rewards-filter-all"
        >
          ${getText('offerwall.filters.all')} (${offerParticipations.length})
        </button>
        <button
          type="button"
          class="reset-button offerwall-offer-categories-btn js-offer-rewards-filter-btn ${
            activeFilter === OFFERS_REWARDS_FILTERS.IN_PROGRESS
              ? 'offerwall-offer-categories-btn-selected'
              : ''
          }"
          data-value="${OFFERS_REWARDS_FILTERS.IN_PROGRESS}"
          data-testid="offer-rewards-filter-all"
        >
          ${getText('offerwall.sort.inProgress')} (${getOngoingOffersCount(
      offerParticipations,
    )})
        </button>
        <button
          type="button"
          class="reset-button offerwall-offer-categories-btn js-offer-rewards-filter-btn ${
            activeFilter === OFFERS_REWARDS_FILTERS.COMPLETED
              ? 'offerwall-offer-categories-btn-selected'
              : ''
          }"
          data-value="${OFFERS_REWARDS_FILTERS.COMPLETED}"
          data-testid="offer-rewards-filter-all"
        >
          ${getText(
            'offerwall.history.offers.completed',
          )} (${getCompletedOffersCount(offerParticipations)})
        </button>
      </section>
    `;
  }

  renderPopupHeader() {
    const { activeOffer: offer } = this;
    const isRtlEnabled =
      document.querySelector('html').getAttribute('dir') === 'rtl';

    if (isRtlEnabled) {
      return `
        ${
          offer.requirements
            ? `
          <span class="text-sm">
            <i>${offer.requirements}</i>
          </span>
          <span class="margin-xxs-horizontal font-bold">
            &middot;
          </span>
        `
            : ''
        }
        <span class="font-bold" data-testid="offer-popup-title">
          ${offer.title}
        </span>
      `;
    }
    return `
      <span class="font-bold" data-testid="offer-popup-title">
        ${offer.title}
      </span>
      ${
        offer.requirements
          ? `
        <span class="margin-xxs-horizontal font-bold">
          &middot;
        </span>
        <span class="text-sm">
          <i>${offer.requirements}</i>
        </span>
      `
          : ''
      }
    `;
  }

  renderPopupSubtasksBar() {
    const { activeOffer: offer } = this;
    const subtasks = offer.subtasks || [];
    let template = '';
    range(subtasks.length).forEach(
      // eslint-disable-next-line no-return-assign
      (index) =>
        (template += `
          <div
            class="offerwall-offers-popup-bar-step${
              subtasks[index].status === OFFERS_HISTORY_STATUS.COMPLETED
                ? ' offerwall-offers-popup-bar-step-completed'
                : ''
            }"
          ></div>`),
    );
    return template;
  }

  renderSubtaskDescription(subtask) {
    const { getText } = this;
    const { status, lastConversion, pendingReason } = subtask;
    if (status === OFFERS_HISTORY_STATUS.COMPLETED && lastConversion) {
      return getText('offerwall.history.activityCompleted').replace(
        'XXXX',
        getLocaleDate(lastConversion),
      );
    }
    if (status === OFFERS_HISTORY_STATUS.PENDING) {
      return getText('offerwall.history.pendingActivity').replace(
        'XXXX',
        pendingReason,
      );
    }
    if (status === OFFERS_HISTORY_STATUS.VIEWED && lastConversion) {
      return getText('offerwall.history.latestActivity').replace(
        'XXXX',
        getLocaleDate(lastConversion),
      );
    }
    return '';
  }

  renderPopupSubtasks() {
    const { activeOffer: offer, getText } = this;
    const subtasks = offer.subtasks || [];
    let template = '';
    subtasks.forEach((subtask) => {
      template += `
        <div
          class="flex flex-column margin-xxs-btm text-sm offerwall-offers-popup-task${
            subtask.status === OFFERS_HISTORY_STATUS.COMPLETED
              ? ' offerwall-offers-popup-task-completed'
              : ''
          }"
        >
          <div class="flex flex-1">
            <div
              class="offerwall-offers-popup-task-icon${
                subtask.status === OFFERS_HISTORY_STATUS.COMPLETED
                  ? ' offerwall-offers-popup-task-icon-completed'
                  : ''
              }"
            >
            </div>
            <div class="flex flex-1 flex-justify--space-between">
              ${
                subtask.status === OFFERS_HISTORY_STATUS.COMPLETED
                  ? `<span>
                      <s>${subtask.title}</s>
                    </span>`
                  : `<span>${subtask.title}</span>`
              }
              ${
                subtask.dynamicDisplayType &&
                subtask.dynamicDisplayType === OFFERS_DYNAMIC_TYPE.COMMISSION
                  ? `<span data-testid="offer-popup-subtask-points">
                      <b>+${subtask.pointsValue}</b> ${offer.pointsName}/$${subtask.dynamicPayout}
                    </span>`
                  : ''
              }
              ${
                subtask.dynamicDisplayType &&
                subtask.dynamicDisplayType === OFFERS_DYNAMIC_TYPE.UP_TO
                  ? `<span data-testid="offer-popup-subtask-points">
                      ${getText('offerwall.offers.upTo')}: <b>${
                      subtask.pointsValue
                    }</b> ${offer.pointsName}
                    </span>`
                  : ''
              }
              ${
                !subtask.dynamicDisplayType
                  ? `<span data-testid="offer-popup-subtask-points">
                      ${offer.pointsName}: <b>+${subtask.pointsValue}</b>
                    </span>`
                  : ''
              }
            </div>
          </div>
            <span class="display-block margin-xxs-top margin-lg-horizontal color-info">
              <i>${this.renderSubtaskDescription(subtask)}</i>
            </span>
        </div>`;
    });
    return template;
  }

  renderPopup() {
    const { activeOffer: offer, getText, loadingOffer } = this;

    if (loadingOffer) {
      return `
        <div class="offerwall-offers-popup">
          <div class="offerwall-offers-popup-body padding-xl-btm">
            <div class="padding-xl-btm">
              <div class="padding-lg-btm">
                ${Pollfish.ui.getSpinner()}
              </div>
            </div>
          </div>
        </div>
      `;
    }

    if (!offer) {
      return '';
    }
    const subtasks = offer.subtasks || [];
    const completedSubtasks = subtasks.filter(
      (subtask) => subtask.status === OFFERS_HISTORY_STATUS.COMPLETED,
    ).length;
    const approvedPointsSum = sumBy(subtasks, 'approvedPoints') || 0;

    return `
      <div class="offerwall-offers-popup">
        <div class="offerwall-offers-popup-body">
          <button
            type="button"
            class="reset-button js-offer-rewards-close-btn offerwall-offers-popup-actions-button-close"
            data-testid="offer-popup-hide"
          >
            <span
              class="icon-close"
              style="
                display:inline-block;
                vertical-align: middle;
                color: black;
                font-size: 18px;
              "
            >
            </span>
          </button>
          <div>
            <header class="offerwall-offers-popup-body-header">
              ${this.renderPopupHeader()}
            </header>
            <div class="flex flex-align-items--center margin-md-top margin-md-btm">
              ${offer.iconUrl &&
                `
                <img
                  class="margin-xs-right offerwall-offers-popup-icon"
                  src="${offer.iconUrl}"
                  alt="${offer.title}"
                />
              `}
              <div class="flex-1">
                <h1 class="text-xxl font-bold margin-reset line-height-reset">
                  ${offer.pointsValue}
                </h1>
                <p class="margin-reset" data-testid="offer-reward-currency">
                  ${offer.pointsName}
                </p>
              </div>
            </div>
            ${
              offer.description
                ? `<span class="text-grey-light">${offer.description}</span>`
                : ''
            }
          </div>
          <div class="divider margin-md-top margin-md-btm"></div>
          ${
            subtasks.length !== 0
              ? `
              <div class="flex text-sm flex-wrap">
                  <span class="text-grey-light">
                    ${getText('offerwall.offers.completed_activities')}:
                  </span>
                  <span class="font-bold margin-xxs-left offer-rtl-text-xxs">
                    ${completedSubtasks}/${subtasks.length}
                  </span>
                  <span class="margin-xxs-horizontal text-grey-light font-bold">
                    &middot;
                  </span>
                  <span class="text-grey-light">
                    ${(getText('offerwall.offers.earned') || '').replace(
                      'XXX',
                      offer.pointsName,
                    )}
                    :
                  </span>
                  <span class="font-bold margin-xxs-left offer-rtl-text-xxs">
                    ${approvedPointsSum}/${offer.pointsValue}
                  </span>
                </div>
                <div class="flex margin-xs-top margin-md-btm">
                  ${this.renderPopupSubtasksBar()}
                </div>
                <div className="display-block">
                  ${this.renderPopupSubtasks()}
                </div>
              `
              : ''
          }
          ${
            offer.contactUrl
              ? `<div class="text-sm">
                  <div class="display-block margin-md-btm">
                    <p class="font-bold text-sm" style="margin: 20px 0 0;">
                      ${getText('offerwall.history.help')}
                    </p>
                    <button
                      type="button"
                      class="reset-button offer-rewards-contact-btn js-offer-rewards-contact-btn"
                      data-testid="offer-rewards-contact-url"
                      data-contacturl="${offer.contactUrl}"
                      style="color: white;"
                    >
                      ${getText('offerwall.history.contact')}
                    </button>
                  </div>
                </div>`
              : ''
          }
        </div>
      </div>
    `;
  }

  render() {
    const { activeTab } = this;

    this.container.innerHTML = `
      ${this.renderPopup()}
      ${this.renderHistoryTab()}
      ${this.renderOffersRewardsFilters()}
      <div class="container points-container margin-sm-top">
        ${
          activeTab === OFFERWALL_TABS.SURVEYS
            ? this.renderSurveysParticipation()
            : ''
        }
        ${
          activeTab === OFFERWALL_TABS.OFFERS
            ? this.renderOfferParticipations()
            : ''
        }
      </div>`;

    return this.container;
  }

  detachHandlers() {
    $('#wrapper').off('tap', '.js-points-tabs');
    $('#wrapper').off('tap', '.js-offer-rewards-filter-btn');
    $('#wrapper').off('tap', '.js-offer-rewards-close-btn');
    $('#wrapper').off('tap', '.js-offer-rewards-contact-btn');
  }

  attachHandlers() {
    this.detachHandlers();
    $('#wrapper').on('tap', '.js-points-tabs', (event) => {
      const { target } = event;
      const { tab } = target.dataset;
      if (this.activeTab === tab) {
        return;
      }
      this.activeTab = tab;
      this.render();
    });

    $('#wrapper').on('tap', '.js-offer-rewards-filter-btn', (e) => {
      e.preventDefault();
      const sender = $(e.target);
      const value = sender.data('value');
      this.selectFilter(value);
      this.render();
    });

    $('#wrapper').on('tap', '.js-offer-rewards-close-btn', (e) => {
      e.preventDefault();
      this.activeOffer = null;
      this.render();
    });
    $('#wrapper').on('tap', '.js-offer-rewards-contact-btn', (e) => {
      e.preventDefault();
      const sender = $(e.target).closest('.js-offer-rewards-contact-btn');
      const contactUrl = sender.data('contacturl');
      Pollfish.mobile.interface.openWebsite(contactUrl);
    });

    $('#wrapper').on('tap', '.js-reward-offer-card', (e) => {
      e.preventDefault();
      const { offerParticipations } = this;
      const sender = $(e.target).closest('.js-reward-offer-card');
      const id = sender.data('id');
      const offer = find(offerParticipations, ['offerId', id.toString()]);
      if (!offer) {
        // eslint-disable-next-line no-console
        console.error('Offer not found!');
        return;
      }
      this.selectOffer(offer);
    });
  }
}

export default PointsPage;
